export default __webpack_public_path__ + "2ee24bb427b18000697e9f2b4d8ba67c.wasm";